<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<div class="content">
			<ul class="meeting_box">
				<li v-for="(item,index) in list.content" :key="index">
					<span class="imgBox"><img :src="item.photoId" alt class></span>
					<div class="fonts">
						<h4>{{item.meeting.name}}</h4>
						<p>举办时间： {{item.meeting.startDate | limitDate}}至{{item.meeting.endDate | limitDate}}</p>
						<p>举办地点： {{item.meeting.provinceName}}<template
								v-if="item.meeting.provinceName !== item.meeting.cityName ">{{item.meeting.cityName}}</template>
							{{item.meeting.address}}</p>
					</div>
					<van-button round type="danger" @click="goDetail(item.meeting.id)">酒店预订</van-button>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	import vHead from "../../components/Subhead.vue";
	import { Uploader, Toast, Button, ImagePreview } from "vant";
	import { registeredMeeting } from "@/api/dictionary";

	export default {
		data() {
			return {
				list: [],
				page: 0,
				title: "已报名会议",
			};
		},
		components: {
			vHead,
			[Uploader.name]: Uploader,
			[Toast.name]: Toast,
			[Button.name]: Button,
			[ImagePreview.name]: ImagePreview,
		},
		methods: {
			getData() {
				let params = {
					memberId: sessionStorage.getItem("memberId")
				};

				registeredMeeting(params, this.page).then(res => {
					if (res.success) {
						this.list = res.result;
					}
				});
			},
			go(pathName) {
				this.$router.push({ name: pathName });
			},
			goDetail(meetingId) {
				this.$router.push({
					name: "hotelList",
					query: { meetingId: meetingId }
				});
			},
			changePage(val) {
				this.page = val;
				this.getData();
			},
		},
		mounted() {
			this.getData();
			//this.title = "aa"
			// this.$route.meta.title = title?title +"会员列表" : "分会会员列表";
		}
	};
</script>

<style lang="less" scoped>
	.means {
		padding: 20px 13px 15px 13px;
		background: url(../../assets/images/hy_bg.jpg);
		background-size: 100%;
		overflow: hidden;

		.van-button {
			float: right;
			background: #fff;
			color: #378be1;
			border: none;
			line-height: 26px;
			height: 35px;
			margin-top: 8px;
		}
	}

	.portrait {
		width: 15%;
		float: left;
	}

	.means_name {
		float: left;
		font-size: 14px;
		color: #fff;
		margin-top: 5px;
		line-height: 24px;
		margin-left: 10px;
	}

	.more {
		float: right;
		margin-top: 25px;
		color: #fff;
	}

	.means_top {
		overflow: hidden;
	}

	.mean_bottom {
		font-size: 14px;
		color: #fff;
		margin-top: 15px;

		.left_c {
			float: left;
			line-height: 26px;
		}
	}

	.menu {
		padding: 15px 0;
		border-bottom: #f2f2f2 8px solid;

		.van-col {
			text-align: center;

			img {
				display: block;
				width: 45%;
				margin: 0 auto;
			}

			span {
				font-size: 13px;
				margin-top: 10px;
				display: block;
			}
		}
	}

	.meeting_box {
		padding: 15px;

		img {
			width: 100%;
			max-height: 5.2rem
		}

		li {
			border-bottom: #dfdfdf solid 1px;
			padding-bottom: 15px;
			position: relative;
			margin-bottom: 15px;
		}

		.van-button {
			float: right;
			background: #378be1;
			color: #fff;
			border: none;
			line-height: 26px;
			height: 30px;
			margin-top: 8px;
			position: absolute;
			bottom: 15px;
			right: 0px;
		}

	}

	.fonts {
		font-size: 13px;
		line-height: 24px;
		margin-top: 10px;
		width: 70%;
	}

	.meeting_box li .imgBox {
		height: 5.98rem;
		background: url(../../assets/images/mor.jpg);
		background-size: 100%;
		display: block;
	}
</style>
